<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/welcome' }">跑腿信息管理</el-breadcrumb-item>
      <el-breadcrumb-item>优惠券管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="状态：">
        <el-select v-model="formInline.status" clearable>
          <el-option label="全部" value=""></el-option>
          <el-option label="已过期" value="-1"></el-option>
          <el-option label="待使用" value="0"></el-option>
          <el-option label="已使用" value="1"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">查询</el-button>
        <el-button size="small" type="primary" icon="el-icon-plus" @click="couponAdd">添加</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="commonMsgData" highlight-current-row v-loading="loading" border
              element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column align="center" prop="startTime" label="有效期开始时间" width="160"/>
      <el-table-column align="center" prop="endTime" label="有效期结束时间" width="160"/>
      <el-table-column align="center" prop="useScope" label="应用范围" width="120" :formatter="useScopeFormatter"/>
      <el-table-column align="center" prop="amount" label="金额（元）" width="120"/>
      <el-table-column align="center" prop="userName" label="领取用户"/>
      <el-table-column align="center" prop="receiveTime" label="领取时间" width="160"/>
      <el-table-column align="center" prop="orderId" label="使用订单"/>
      <el-table-column align="center" prop="useTime" label="使用时间" width="160"/>
      <el-table-column align="center" prop="status" label="状态" :formatter="statusFormatter" width="120"/>
      <el-table-column align="center" label="操作" width="200">
        <template slot-scope="scope">
<!--          <el-button size="mini" type="warning" v-if="scope.row.status == 0" @click="remove(scope.$index, scope.row)">取消</el-button>-->
          <el-button size="mini" type="danger" v-if="scope.row.status != 1" @click="remove(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageParam" @callFather="callFather"></Pagination>
    <!-- 新增编辑界面 -->
    <el-dialog title="优惠券发放" :close-on-click-modal="false" :visible.sync="editFormVisible" width="50%" @close='closeDialog("edit")'>
      <el-form label-width="95px" ref="editForm" :model="editForm" :rules="rules">
        <el-row :gutter="20">
          <el-col :span="24">
            <div class="grid-content bg-purple">
              <el-form-item label="有效期" prop="dateTimeRange">
                <el-date-picker v-model="editForm.dateTimeRange" type="datetimerange" range-separator="至"
                                start-placeholder="开始时间" end-placeholder="结束时间"
                                value-format="yyyy-MM-dd HH:mm:ss" style="width: 100%;"/>
              </el-form-item>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <div class="grid-content bg-purple">
              <el-form-item label="金额（元）" prop="amount">
                <el-input-number v-model="editForm.amount" :min="1" :max="9999" :step="1" placeholder="请输入金额"
                                 style="width: 100%;"/>
              </el-form-item>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="grid-content bg-purple">
              <el-form-item label="发放数量" prop="issuedNum">
                <el-input-number v-model="editForm.issuedNum" :min="1" :max="9999" :step="1"
                                 placeholder="请输入发放数量" style="width: 100%;"/>
              </el-form-item>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='closeDialog("editForm")'>取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('editForm')">保存
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// 导入请求方法
import {couponPage, couponSave, couponDelete} from '../../api/couponMG'
import Pagination from '../../components/Pagination'

export default {
  data() {
    return {
      commonMsgData: [],  //消息通知数据
      loading: false, //是显示加载
      // 请求数据参数
      formInline: {
        page: 1,
        limit: 20,
        status: ''
      },
      editFormVisible: false, //新增框是否显示
      editForm: {
        dateTimeRange: null,
        amount: '',
        issuedNum: ''
      },
      rules: {
        dateTimeRange: [{type: 'array', required: true, message: '请选择优惠券有效期', trigger: 'blur'}],
        amount: [{required: true, message: '请输入优惠券金额', trigger: 'blur'}],
        issuedNum: [{required: true, message: '请输入优惠券发放数量', trigger: 'blur'}]
      },
      // 分页参数
      pageParam: {
        currentPage: 1,
        pageSize: 20,
        total: 20
      }
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */
  watch: {},
  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline)
  },
  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    // 获取数据方法
    getdata(parameter) {
      this.loading = true
      this.loading = false
      couponPage(parameter).then(res => {
        this.loading = false
        if (res.code != 0) {
          this.$message({type: 'info', message: res.msg})
        } else {
          this.commonMsgData = res.data.list
          // 分页赋值
          this.pageParam.currentPage = res.data.page
          this.pageParam.pageSize = res.data.limit
          this.pageParam.total = res.data.total
        }
      })
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.limit = parm.pageSize
      this.getdata(this.formInline)
    },
    //搜索事件
    search() {
      this.getdata(this.formInline)
    },
    //优惠券新增
    couponAdd() {
      this.editFormVisible = true;
      this.editForm.dateTimeRange = null,
        this.editForm.amount = 1;
      this.editForm.issuedNum = 1;
    },
    //新增、编辑界面保存
    submitForm(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          this.editForm.startTime = this.editForm.dateTimeRange[0];
          this.editForm.endTime = this.editForm.dateTimeRange[1];
          let params = {
            'useScope': 'RUN_ERRANDS',
            'startTime': this.editForm.dateTimeRange[0],
            'endTime': this.editForm.dateTimeRange[1],
            'amount': this.editForm.amount,
            'issuedNum': this.editForm.issuedNum
          }
          couponSave(params).then(res => {
            this.editFormVisible = false
            this.loading = false
            if (res.code == 0) {
              this.getdata(this.formInline)
              this.$message({type: 'success', message: '保存成功！'})
              this.$refs['editForm'].resetFields();
            } else {
              this.$message({type: 'warning', message: res.msg})
            }
          }).catch(err => {
            this.editFormVisible = false
            this.loading = false
            this.$message.error('保存失败，请稍后再试！')
          })
        } else {
          return false
        }
      })
    },
    // 关闭编辑、增加弹出框
    closeDialog(dialog) {
      this.editFormVisible = false
    },
    //删除
    remove(index, row) {
      let id = row.id;
      this.$confirm('删除无法撤回，确认删除?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        couponDelete({'id': id}).then(res => {
          if (res.code == 0) {
            this.$message({type: 'success', message: '删除成功!'})
            this.getdata(this.formInline)
          } else {
            this.$message({type: 'info', message: res.msg})
          }
        }).catch(err => {
          this.loading = false
          this.$message.error('操作失败，请稍后再试！')
        })
      }).catch(() => {
        this.$message({type: 'info', message: '已取消此操作！'})
      })
    },
    //应用范围格式化
    useScopeFormatter: function (row, column) {
      if (row.useScope == 'RUN_ERRANDS') {
        return '跑腿';
      }
      return null;
    },
    //状态格式化
    statusFormatter: function (row, column) {
      let name = "";
      switch (row.status) {
        case -2:
          name = "已取消";
          break;
        case -1:
          name = "已过期";
          break;
        case 0:
          name = "待使用";
          break;
        case 1:
          name = "已使用";
          break;
      }
      return name;
    },
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/order/coupon.vue